import {CompletePayroll} from "../../../../app/interfaces";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {updatePayrollState} from "../../../../app/payroll/selectors";
import {setEmployeePaid} from "../../../../app/payroll/actions";
import {FETCH_STATUS_LOADING} from "../../../../utils/constants";
import {PopupAskForConfirmation, PopupLoading, PrimaryButton} from "../../../../components";
import React, {useState} from "react";
import {EorPartnerPaidContainer} from "../PayrollPartnerPayment/styles";
import PayrollDetailsView from "../PayrollDetailsView";

const PayrollNotifyCustomer = ({payroll}: {payroll: CompletePayroll}) => {

    const {t} = useTranslation();
    const dispatch = useDispatch();

    const statusUpdate = useSelector(updatePayrollState)
    const [showAskForConfirmation, setShowAskForConfirmation] = useState<boolean>(false)

    const handleSetEmployeePaid = () => {
        setShowAskForConfirmation(false)
        dispatch(setEmployeePaid(
            {
                payrollId: payroll._id,
                employeeId: payroll.eor_employee._id
            }
        ) as any)
    }

    if(statusUpdate === FETCH_STATUS_LOADING){
        return <PopupLoading isOpen={true}/>
    }

    return <>
        {showAskForConfirmation && <PopupAskForConfirmation
            title={t('wait_a_minute') as string}
            subtitle={t('notify_customer_about_payment_alert') as string}
            isOpen={showAskForConfirmation}
            onConfirm={handleSetEmployeePaid}
            onCancel={() => setShowAskForConfirmation(false)}
            type='hand_stop'
        />}

        <EorPartnerPaidContainer>
            <div className="label">
                <h1>{t('notify_user_and_customer_of_payment_title')}</h1>
                <h3>{t('notify_user_and_customer_of_payment_message')}</h3>
            </div>
            <div className="action">
                <PrimaryButton onClick={() => setShowAskForConfirmation(true)}>
                    {t('send_notification')}
                </PrimaryButton>
            </div>
        </EorPartnerPaidContainer>
        <PayrollDetailsView payroll={payroll}/>
    </>
}

export default PayrollNotifyCustomer;
